export default "__VITE_ASSET__B3JBzqW3__"